import ExplorerCard from "./ExplorerCard";
import { connect } from "react-redux";
import BoundCardFields from "components/Card/BoundCardFields";
import BoundCardField from "components/Card/BoundCardField";
import actionsForNavigation from "store/actions/navigation";
import actionsForRecordset from "store/actions/recordset";

function mapStateToProps(actionsForRecordset, accessorsForRecordset) {

    const CardFields = BoundCardFields(actionsForRecordset, accessorsForRecordset);
    const CardField = BoundCardField(actionsForRecordset, accessorsForRecordset);

    return (state, ownProps) => {
        return {
            CardFields: ownProps.CardFields || CardFields,
            CardField: ownProps.CardField || CardField,
            // status: accessorsForRecordset.getField(state, "status")
        };
    };
}

function mapDispatchToProps() {    
    return (dispatch) => ({
        openChild: (name, route) => dispatch(actionsForNavigation.openChild(name, route)),
        advance: (status) => dispatch(actionsForRecordset.updateRecord({ status }))
    });
}

export default (actionsForRecordset, accessorsForRecordset)=>connect(mapStateToProps(actionsForRecordset, accessorsForRecordset), mapDispatchToProps())(ExplorerCard);
